module.exports = "/images/role-it-developer-icon.svg?cbdeb27410aa873f218d31aaf36fb448";